export const capitalizeFirstLetter = (input: string): string =>
  `${input.charAt(0).toUpperCase()}${input.slice(1)}`;

// this function is used to convert default folder name to human readable
// string, e.g. `building-and-visuals` => "Building And Visuals", so it looks
// better in the breadcrumb
export default function capitalize(input: string): string {
  return input
    .split('-')
    .map((part) => {
      if (part === 'and') {
        return 'and';
      }
      if (part === 'ui') {
        return 'UI';
      }
      return capitalizeFirstLetter(part);
    })
    .join(' ');
}
